module.exports = __webpack_public_path__ + "img/NZL.bce17976.svg";